<script setup lang="ts">
    import { Card, CardContent } from '@/components/ui/card';
    import { cn } from '@/lib/utils';
    import type { HTMLAttributes } from 'vue';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <Card :class="cn('m-1.5 min-h-0 flex-1', props.class)">
        <CardContent class="h-full">
            <slot />
        </CardContent>
    </Card>
</template>
